import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Button,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import { fetchUserService } from "../../services/authService";
import useStore from "../../useStore";

function PermissionTable() {
  const navigate = useNavigate();
  const [openPermissions, setOpenPermissions] = useState({});
  const [userData, setUserData] = useState([]);
  const { setPermissionsId, setIsPermissionUpdate, setPermissionsData } =
    useStore();

  const handleTogglePermissions = (index) => {
    setOpenPermissions((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const getData = async () => {
    try {
      const getUser = await fetchUserService();
      setUserData(getUser); // Set the fetched user data
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const handleEdit = async (id, data) => {
    setPermissionsId(id);
    setIsPermissionUpdate(true);
    setPermissionsData(data);
    navigate("/permissions/create-user");
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <Box>
      {/* Create User button */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setIsPermissionUpdate(false);
            navigate("/permissions/create-user");
          }}
        >
          Create User
        </Button>
      </Box>

      <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", color: "#5252ff" }}>
                SL NO
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#5252ff" }}>
                Name
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#5252ff" }}>
                Phone Number
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#5252ff" }}>
                Email
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#5252ff" }}>
                Permissions
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#5252ff" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userData.map((user, index) => (
              <TableRow key={user._id} hover>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{user.userName}</TableCell>
                <TableCell>
                  {user.primaryPhone?.contactValue || "N/A"}
                </TableCell>
                <TableCell>{user.email || "N/A"}</TableCell>
                <TableCell>
                  <List dense disablePadding>
                    {user.permissions[0]?.permissions
                      .filter((perm) => perm.access)
                      .slice(0, 2)
                      .map((permission, i) => (
                        <ListItem key={permission._id} sx={{ padding: 0 }}>
                          <ListItemText
                            primary={`${i + 1}. ${permission.title}`}
                          />
                        </ListItem>
                      ))}
                    {user.permissions[0]?.permissions.filter(
                      (perm) => perm.access
                    ).length > 2 && (
                      <ListItem
                        button
                        onClick={() => handleTogglePermissions(index)}
                        sx={{ padding: 0 }}
                      >
                        <ListItemText
                          primary={
                            openPermissions[index]
                              ? "Show less"
                              : `+ ${
                                  user.permissions[0]?.permissions.filter(
                                    (perm) => perm.access
                                  ).length - 2
                                } more`
                          }
                        />
                        <IconButton size="small" edge="end">
                          {openPermissions[index] ? (
                            <ExpandLessIcon fontSize="small" />
                          ) : (
                            <ExpandMoreIcon fontSize="small" />
                          )}
                        </IconButton>
                      </ListItem>
                    )}
                  </List>
                  <Collapse
                    in={openPermissions[index]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List dense disablePadding>
                      {user.permissions[0]?.permissions
                        .filter((perm) => perm.access)
                        .slice(2)
                        .map((permission, i) => (
                          <ListItem key={permission._id} sx={{ padding: 0 }}>
                            <ListItemText
                              primary={`${i + 3}. ${permission.title}`}
                              sx={{ paddingLeft: 2 }}
                            />
                          </ListItem>
                        ))}
                    </List>
                  </Collapse>
                </TableCell>
                <TableCell>
                  <IconButton color="primary" size="small">
                    <EditIcon
                      onClick={() =>
                        handleEdit(user?.permissions[0]?._id, user)
                      }
                    />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default PermissionTable;
